import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import { rel } from '@ifeng-fe/container_channel/common/client/utils/rel';

class TabTitle extends React.PureComponent {
    static propTypes = {
        title: PropTypes.string,
        tabTits: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        current: PropTypes.string,
        callback: PropTypes.func,
    };

    handleMouseOver = e => {
        const index = e.currentTarget.getAttribute('index');

        this.props.callback(index);
    };

    /**
     * 渲染组件
     */
    render() {
        const { title, tabTits, current } = this.props;

        return (
            <div className={styles.title}>
                <h3>{title}</h3>
                <ul>
                    {Object.keys(tabTits).map((key, index) => (
                        <li
                            key={index}
                            index={key}
                            className={key === current ? styles.cur : ''}
                            onMouseOver={this.handleMouseOver}>
                            {typeof tabTits[key] === 'string' && tabTits[key]}
                            {typeof tabTits[key] === 'object' && (
                                <a href={tabTits[key].url} rel={rel} target="_blank">
                                    {tabTits[key].name}
                                </a>
                            )}
                        </li>
                    ))}
                </ul>
            </div>
        );
    }
}

export default errorBoundary(TabTitle);
